import { AuthorizedService } from './authorized-service.base';
import { Api, Defaults } from 'domain/core';
import {
  Dataset,
  ValidationReport,
  VariableMapping,
  RestQueryExtras,
  DatasetInfo,
  DatasetState,
} from 'domain/models';
import { toPaginationQuery, argsToQuery } from 'domain/utils';
import { ExperimentsService } from './experiments.service';


export class DatasetService extends AuthorizedService {
  getDatasetsGeoJSON(project: string, wkt: string) {
    return {
      coordinates: [], // FIXME: Remove this method
    }
  }

  public getDatasetNearestpointsGeoJSON(project: string, wkt: string) {
    return {
      coordinates: [], // FIXME: Remove this method
    }
  }

  public async getDatasetState(uploadId: number): Promise<DatasetState> {
    const url =
      Api.baseUrl + Api.datasets.state.replace('{{id}}', uploadId.toString());
    return await this.fetch(url, { method: 'GET' }).then((r) => r.json());
  }

  public async getDatasetInfo(id: string): Promise<DatasetInfo[] | null> {
    const url = Api.baseUrl + Api.datasets.info.replace('{{id}}', id);
    return await this.fetch(url, { method: 'GET' }).then((r) => {
      if (r.status === 200) {
        return r.json();
      } else {
        return new Promise((res, rej) => res(null));
      }
    });
  }

  public async discardDataset(uploadId: number): Promise<void> {
    return await this.fetch(Api.baseUrl + Api.datasets.base + `/${uploadId}`, {
      method: 'DELETE',
    }).then();
  }

  public async activeDataset(uploadId: number): Promise<void> {
    const payload = { state: 'ACTIVE' };
    const url =
      Api.baseUrl + Api.datasets.state.replace('{{id}}', uploadId.toString());
    return await this.fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then();
  }

  public async getDataset(id: string): Promise<Dataset> {
    const datasets = await this.getDatasets();
    const dataset = datasets.find((d) => d.name === id);
    if (!dataset) {
      throw new Error('Dataset not found');
    }
    return dataset;
  }

  public async getDatasets(
    extras: RestQueryExtras = Defaults.defaultRestExtras,
    args?: any
  ): Promise<Dataset[]> {
    const fields = await new ExperimentsService().getNewExperimentFields();

    return fields.models.map(f => {
      return {
        id: -1,
        type: f.type == 'observation' ? 'calibration' : 'projection',
        name: f.name,
        parent: f.parent ?? null,
        description: f.name,
        startDate: new Date(2015, 1, 1),
        endDate: new Date(2100, 1, 1),
        spatialCoverage: 'WORLD',
        variables: f.variables,
        models: [],
        scenarios: f.experiments,
      }
    })
  }
}
